import styles from "../../assets/css/remittance.calculator.module.scss";

import RemittanceHome from "./RemittanceHome";

const RemittanceCalculator = () => {
  return (
    <>
      <div className={styles.calculatorContainer}>
        <RemittanceHome fromCalculatorPage={true} />
      </div>
    </>
  );
};

export default RemittanceCalculator;
